/**
 * @typedef {object} Respondent
 * @property {string} emailKey - Lowercased email; the key the choice is stored under.
 * @property {string} email - Email as it appears in the file (first column).
 * @property {string|null} matchedPersonaId - Persona matched by email, or null when none.
 *
 * @typedef {object} PersonaOption
 * @property {string} ID - Persona id.
 * @property {string} Name - Display name.
 */

/**
 * Review table: one row per unique respondent email in the import. Shows which existing
 * participant the data attaches to (matched by email) and lets the user change it or choose
 * to create a new participant. Mirrors ImportMappingTable's look.
 *
 * @param {object} props
 * @param {Respondent[]} props.respondents - Unique respondents parsed from the file.
 * @param {PersonaOption[]} props.personas - Existing participants for the dropdown.
 * @param {Object<string,string>} props.choices - emailKey → chosen persona id or 'new'.
 * @param {(emailKey: string, value: string) => void} props.onChange - Selection handler.
 */
const ImportPersonaTable = ({ respondents, personas, choices, onChange }) => {
    const sorted = [...personas].sort((a, b) =>
        String(a.Name || "").localeCompare(String(b.Name || ""))
    );

    return (
        <table className="import-mapping-table">
            <thead>
                <tr>
                    <th>E-MAIL IN BESTAND</th>
                    <th>GEKOPPELDE DEELNEMER</th>
                </tr>
            </thead>
            <tbody>
                {respondents.map((r) => {
                    const value = choices[r.emailKey] ?? (r.matchedPersonaId || "new");
                    const isNew = value === "new";
                    return (
                        <tr key={r.emailKey} className={isNew ? "import-mapping-row-unmatched" : ""}>
                            <td>
                                <span className="import-mapping-question-label">{r.email}</span>
                                <span className="import-mapping-effect-band">
                                    {r.matchedPersonaId
                                        ? "Gekoppeld op e-mail"
                                        : "Geen match — nieuwe deelnemer"}
                                </span>
                            </td>
                            <td>
                                <select value={value} onChange={(e) => onChange(r.emailKey, e.target.value)}>
                                    <option value="new">+ Nieuwe deelnemer aanmaken</option>
                                    {sorted.map((p) => (
                                        <option key={p.ID} value={p.ID}>
                                            {p.Name}
                                        </option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default ImportPersonaTable;
